import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';

const NEIGHBORHOODS = [
  'Downtown SA', 'North SA', 'Alamo Heights', 'Stone Oak', 'Leon Valley',
  'Converse', 'Live Oak', 'Helotes', 'South SA', 'Medical Center',
];

const sectionVariants = {
  hidden: { opacity: 0, y: 18 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const ServiceArea = () => {
  return (
    <section id="service-area" className="scroll-mt-24 bg-white py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-start gap-10 lg:gap-16">
          {/* Left Column */}
          <motion.div
            variants={sectionVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.25 }}
          >
            <span className="text-xs uppercase tracking-[0.22em] text-kv-gold font-sans font-semibold mb-4 block">
              Service Area
            </span>
            <h2 className="text-3xl sm:text-4xl font-display tracking-tight text-kv-black-2 leading-snug mb-6">
              Based in San Antonio.{' '}
              <span className="block">Serving San Antonio.</span>
            </h2>
            <p className="text-base text-gray-500 leading-relaxed max-w-lg font-sans mb-8">
              We're a local, San Antonio-based vending company. That means faster response times,
              personal service, and a team that genuinely knows the city. We serve businesses across
              the greater San Antonio metro area.
            </p>
            <div className="flex flex-wrap gap-2">
              {NEIGHBORHOODS.map((hood) => (
                <span
                  key={hood}
                  data-testid={`area-tag-${hood.toLowerCase().replace(/\s+/g, '-')}`}
                  className="inline-flex items-center rounded-full bg-kv-mist border border-black/6 px-4 py-1.5 text-xs font-medium text-kv-black-2 font-sans"
                >
                  {hood}
                </span>
              ))}
            </div>
          </motion.div>

          {/* Right Column - Map Placeholder */}
          <motion.div
            variants={sectionVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.25 }}
            className="relative"
          >
            <div className="rounded-2xl border border-black/8 overflow-hidden bg-kv-mist aspect-[4/3] shadow-[0_1px_0_rgba(17,17,20,0.04),0_10px_30px_rgba(17,17,20,0.05)]">
              <iframe
                title="Keyless Vending Service Area - San Antonio, TX"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d222540.04634782tried4!2d-98.57439554062497!3d29.458517300000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c58af04d00eaf%3A0x856e8b57a9f0b2a4!2sSan%20Antonio%2C%20TX!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
